//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import rtc from '~/components/liveroom/mixin/rtc'
import { setFullScreen, exitFullScreen } from '~/utils/utils'
import livePlay from '~/components/liveroom/livePlay.vue'
let utils = {}
export default {
  components: {
    'live-play': livePlay // 弹框
  },
  mixins: [rtc],
  props: {
    location: {
      type: [Number, String],
      default: 0
    }
  },
  data () {
    return {
      anchorStream: null,
      anchorShareStream: null,
      full_show: true, // 全屏  小屏
      bt_show: true, // 暂停状态
      control_show: false, // 按钮是否展示
      text: '',
      Horvscreen: false, // 横竖屏样式
      isVerticalScreen: null
    }
  },
  computed: {
    ...mapState({
      sdkAppId: 'sdkAppId',
      userSig: 'userSig',
      roomId: 'roomId',
      userInfo: 'liveuserInfo',
      lineType: 'lineType',
      playState: 'playState',
      anchorUserId: 'anchorUserId',
      layout: 'layout'
    }),
    userId () {
      return this.userInfo.userId
    },
    anchorShareUserId () {
      return `share_${this.anchorUserId}`
    },
    userData () {
      return {
        sdkAppId: this.sdkAppId,
        userSig: this.userSig,
        userId: this.userId,
        roomId: this.roomId
      }
    }
  },
  watch: {
    userData: {
      immediate: true,
      async handler (val) {
        if (val.sdkAppId && val.userSig && val.userId && val.roomId) {
          await this.initClient() // 初始化客户端
          await this.handleJoin('audience') // 进房
        }
      }
    },
    playState (val) {
      console.log('val:触发流 ', val)
      // this.$store.commit('set_playing', val)
      if (val === 'playing') { // 播放中
        this.playAnchorStream()
        this.playAnchorShareStream()
      } else if (val === 'paused') { // 暂停
        this.stopAnchorStream()
        this.stopAnchorShareStream()
      }
    },
    // 点击布局按钮触发布局改变
    layout (val) {
      this.handleRotateClass()
      if (utils.isAndroid) {
        if (val === 'vertical') {
          utils.exitFullScreen(document.querySelector('body'))
        } else if (val === 'horizontal') {
          utils.setFullScreen(document.querySelector('body'))
        }
      }
    }
  },
  created () {

  },
  mounted () {
    window.onresize = () => {
      if (document.fullscreenElement) {
        console.log('进入全屏')
        // this.full_show = !this.full_show;
      } else {
        // TODO...
        console.log('退出全屏')
        this.full_show = true
      }
    }
    // 处理页面数据
    this.$nextTick(() => {
      utils = require('@/utils/utils')
      // 处理页面布局
      window.addEventListener('onorientationchange' in window ? 'orientationchange' : 'resize', this.handleAppLayout)
      this.handleAppLayout()
      console.log('this.$refs.chatContent: ', this.$refs.chatContent)
      // this.$refs.chatContent.scrollTop = this.$refs.chatContent.scrollHeight;
      // $('#zimu').animate({ scrollTop: $('#zimu').outerHeight() + $('#zimu').scrollTop() + 'px' }, 100);
    })
  },
  methods: {
    // 横竖屏切换
    toggleLayout () {
      this.Horvscreen = !this.Horvscreen
      this.$emit('fullscreen', this.Horvscreen)
      if (this.layout === 'vertical') {
        this.$store.commit('UPDATE_LAYOUT', 'horizontal')
      } else if (this.layout === 'horizontal') {
        this.$store.commit('UPDATE_LAYOUT', 'vertical')
      }
    },
    handleAppLayout () {
      this.isVerticalScreen = utils.isVerticalScreen()
      this.$store.commit('UPDATE_LAYOUT', this.isVerticalScreen ? 'vertical' : 'horizontal')
    },
    handleRotateClass () {
      const screenWidth = document.documentElement.clientWidth
      const screenHeight = document.documentElement.clientHeight
      if (this.isVerticalScreen && this.layout === 'horizontal') {
        this.$refs.zhibo.style.width = `${screenHeight}px`
        this.$refs.zhibo.style.height = `${screenWidth}px`
        this.$refs.zhibo.style.transform = 'rotate(90deg)'
        this.$refs.zhibo.style.transformOrigin = '0 0'
        this.$refs.zhibo.style.left = `${screenWidth}px`
        return
      }
      if (!this.isVerticalScreen && this.layout === 'vertical') {
        this.$refs.zhibo.style.width = `${screenHeight}px`
        this.$refs.zhibo.style.height = `${screenWidth}px`
        this.$refs.zhibo.style.transform = 'rotate(-90deg)'
        this.$refs.zhibo.style.transformOrigin = '0 0'
        this.$refs.zhibo.style.top = `${screenHeight}px`
        return
      }
      this.$refs.zhibo.style = {}
    },
    handlePlay () {
      this.bt_show = true
      this.text = this.$v('直播')
      this.$store.commit('UPDATE_PLAY_STATE', 'playing')
      this.$store.commit('set_stop_show', false)
      this.$store.commit('setanchor', true)
      const livecode = this.$route.params.id && this.$route.params.id.split('.')[0]
      this.$cookies.set(`anchor${livecode}`, true)
    },
    handstop () {
      this.bt_show = false
      this.text = this.$v('暂停')
      this.$store.commit('UPDATE_PLAY_STATE', 'paused')
      this.$store.commit('setanchor', true)
      const livecode = this.$route.params.id && this.$route.params.id.split('.')[0]
      this.$cookies.set(`anchor${livecode}`, true)
    },
    handlePause () {
      this.text = this.$v('暂停')
      this.$store.commit('UPDATE_PLAY_STATE', 'paused')
      this.$store.commit('set_stop_show', true)
      this.$store.commit('setanchor', true)
      const livecode = this.$route.params.id && this.$route.params.id.split('.')[0]
      this.$cookies.set(`anchor${livecode}`, true)
      this.$nextTick(() => {
        this.bt_show = false
      })
    },
    handleFullScreen () {
      this.full_show = !this.full_show
      setFullScreen(document.querySelector('#player-rtc-container'))
    },
    handleQuitFullScreen () {
      this.full_show = !this.full_show
      exitFullScreen()
    },
    playAnchorStream () { /// 共享流
      this.anchorStream && this.playStream(this.anchorStream, 'main-stream')
    },
    stopAnchorStream () { // 暂停
      this.anchorStream && this.anchorStream.stop()
    },
    playAnchorShareStream () { // 内容直播流
      this.anchorShareStream &&
                this.playStream(this.anchorShareStream, 'share-stream', { objectFit: 'contain' })
    },
    stopAnchorShareStream () { // 内容直播流暂停
      this.anchorShareStream && this.anchorShareStream.stop()
    },
    handleSubscribedStream (remoteStream) {
      console.log('abcdef', remoteStream.getUserId())
      if (remoteStream.getUserId() === this.anchorUserId) {
        this.anchorStream = remoteStream
        if (this.playState === 'playing') {
          this.playAnchorStream()
        }
      }
      if (remoteStream.getUserId() === this.anchorShareUserId) {
        this.anchorShareStream = remoteStream
        if (this.playState === 'playing') {
          this.playAnchorShareStream()
        }
      }
    },
    handleStreamRemoved (remoteStream) { //
      if (remoteStream.getUserId() === this.anchorUserId) {
        this.anchorStream = null
        if (this.playState === 'playing') {
          // this.$emit('switch_state');
          this.stopAnchorStream()
        }
      }
      if (remoteStream.getUserId() === this.anchorShareUserId) {
        this.anchorShareStream = null
        if (this.playState === 'playing') {
          this.stopAnchorShareStream()
        }
      }
    }
  }
}
